import { render } from "./SendToken.vue?vue&type=template&id=4d2288bb&scoped=true"
import script from "./SendToken.vue?vue&type=script&lang=js"
export * from "./SendToken.vue?vue&type=script&lang=js"

import "./SendToken.vue?vue&type=style&index=0&id=4d2288bb&lang=scss"
import "./SendToken.vue?vue&type=style&index=1&id=4d2288bb&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d2288bb"]])

export default __exports__